module.exports = __webpack_public_path__ + "img/lapar_transparent.8cb23ebb.png";